import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ProtectedRoute from "./Protected/ProtectedRoute";

//Common Components
import "./App.css";
import HomePage from "./components/Home/Home";
import Toolbar from "./components/Toolbar/Toolbar";
import LeftToolBar from "./components/LeftToolbar/LeftToolbar";

/// Screens
import Schools from "./components/School/School";
import Courses from "./components/Courses/Courses";
import Teachers from "./components/Teachers/Teachers";
import Students from "./components/Students/Students";
import SchoolClasses from "./components/SchoolClasses/SchoolClasses";
import SchoolCourses from "./components/SchoolCourses/SchoolCourses";
import AddUser from "./components/AddUser/Adduser";
import Utilites from "./components/Utiles/utiles";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userdata: JSON.parse(localStorage.getItem("kokos_userdata")),
    };
  }

  userDataChange = (userDetails) => {
    this.setState((state, props) => {
      return {
        userdata: userDetails,
      };
    });
  };

  render() {

// This has been hacked for automating login by students
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const emailParam = urlParams.get("email");
    const passwordParam = urlParams.get("password");
    if (emailParam && passwordParam) {
      document.getElementById("username").value = emailParam;
      document.getElementById("password").value = passwordParam;
      const submitButtons=document.getElementsByClassName("HomepageLogin")
        submitButtons[0].click()
    }
  }, 300);
});
// End of the hack

    return (
      <div className="App" style={{ height: "100vh", overflow: "hidden" }}>
        <Toolbar user={this.state.userdata} />
        <main style={{ display: "flex", flexDirection: "row" }}>
          <LeftToolBar />
          <Switch>
            <Route
              path="/"
              exact
              render={(props) => (
                <HomePage onUserDataChange={this.userDataChange} />
              )}
            />
            {this.state.userdata?.role_code !== "STDADMN" &&
            this.state.userdata?.role_code !== "ADMN" ? (
              <ProtectedRoute path="/Schools" component={Schools} />
            ) : null}
            {this.state.userdata?.role_code !== "STDADMN" ? (
              <ProtectedRoute path="/Courses" component={Courses} />
            ) : null}
            {this.state.userdata?.role_code !== "STDADMN" ? (
              <ProtectedRoute path="/Teachers" component={Teachers} />
            ) : null}
            <ProtectedRoute path="/Students" component={Students} />
            {this.state.userdata?.role_code !== "STDADMN" ? (
              <ProtectedRoute path="/SchoolClasses" component={SchoolClasses} />
            ) : null}
            {this.state.userdata?.role_code !== "STDADMN" ? (
              <ProtectedRoute path="/SchoolCourses" component={SchoolCourses} />
            ) : null}
            {this.state.userdata?.role_code !== "STDADMN" &&
            this.state.userdata?.role_code !== "ADMN" ? (
              <ProtectedRoute path="/AddUser" component={AddUser} />
            ) : null}
            {this.state.userdata?.role_code !== "STDADMN" ? (
              <ProtectedRoute path="/Utilites" component={Utilites} />
            ) : null}
          </Switch>
        </main>
      </div>
    );
  }
}

function AppRouter() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppRouter;
